import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { GuardrailSnapshot, KillSwitchToggleReq } from '@/api/types'

/**
 * useGuardrail polls /api/admin/guardrail every 15s. The KillSwitchBanner uses
 * this same hook so the data is shared and the banner is always in sync.
 */
export function useGuardrail() {
  return useQuery<GuardrailSnapshot>({
    queryKey: ['guardrail'],
    queryFn: api.guardrail,
    refetchInterval: 15_000,
  })
}

/**
 * useKillSwitchMutation toggles the kill switch and invalidates the guardrail
 * query so every screen re-renders against the new state.
 */
export function useKillSwitchMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: KillSwitchToggleReq) => api.killSwitch(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['guardrail'] }),
  })
}
